// src/components/organisms/integrations/salesforce/create/blocks/automation-account-block.tsx
import {
  SalesforceActions,
  SalesforceIntegrationId,
  RLProjectFieldMapping,
} from 'module/api/integrations/salesforce/types';
import { Loading } from 'module/ui/components/atoms/loading';
import { useSalesForceActionFieldsQuery } from 'queries/salesforce';
import { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { BlockList } from 'components/organisms/signal/detail/block-list/list';
import { ActionDrawer } from '../action-drawer';
import { useAutomationContext } from '../automation-context';
import { getFields } from './shared/block-utils';
import { RenderBlockDetails } from './shared/render-block-details';

export const AutomationAccountBlock: FC = () => {
  const { integrationId } = useParams<SalesforceIntegrationId>();
  const { automationDetails, setAutomationDetails } = useAutomationContext();
  const [actionDrawerVisible, setActionDrawerVisible] = useState(false);

  const salesForceType = SalesforceActions.Account;

  const fieldsKey = getFields(salesForceType);

  const {
    salesforceObject: selectedSalesforceObject,
    salesForceType: selectedSalesForceType,
  } = automationDetails || {};

  const { value } = selectedSalesforceObject || {};

  // For project automation flow, pass the companyObject placeholder
  const triggerObjectParentPlaceholder =
    selectedSalesForceType === SalesforceActions.Project
      ? automationDetails?.rocketlaneFields?.companyObject?.valueStr
      : undefined;

  const { data: accountFields = [], status, isFetching } =
    useSalesForceActionFieldsQuery(
      parseInt(integrationId || '0'),
      String(value),
      salesForceType,
      triggerObjectParentPlaceholder,
      {
        enabled: !!value,
      },
    );
  const isFieldsLoading = status === 'pending' || isFetching;

  const onSave = (updatedFields: RLProjectFieldMapping) => {
    const fields = Object.keys(updatedFields).reduce((acc, key) => {
      acc[key] =
        key !== 'teamMembers'
          ? updatedFields[key] != null
            ? {
              ...updatedFields[key],
              label:
                updatedFields[key]?.valueMeta?.fieldLabel ??
                updatedFields[key]?.label,
            }
            : undefined
          : updatedFields[key];

      return acc;
    }, {});

    setAutomationDetails({
      [fieldsKey]: fields,
    });
  };

  return (
    <>
      <BlockList.Item
        disabled={!value || isFieldsLoading}
        onClick={() => setActionDrawerVisible(true)}
      >
        <BlockList.Item.Label data-required="true">
          <BlockList.Item.Label.Text>
            <FormattedMessage
              id={'settings.integrations.create.automation.account.label'}
            />
          </BlockList.Item.Label.Text>
        </BlockList.Item.Label>
        <BlockList.Item.Content>
          {isFieldsLoading ? (
            <Loading />
          ) : (
            <RenderBlockDetails
              actions={automationDetails?.[fieldsKey] ?? {}}
              fields={accountFields}
            />
          )}
        </BlockList.Item.Content>
      </BlockList.Item>
      <ActionDrawer
        fields={accountFields ?? []}
        fieldsStatus={isFieldsLoading ? 'pending' : 'success'}
        visible={actionDrawerVisible}
        value={automationDetails?.[fieldsKey] ?? undefined}
        handleModalVisibility={setActionDrawerVisible}
        onSave={onSave}
        onClose={() => setActionDrawerVisible(false)}
        label="account"
      />
    </>
  );
};
